import { PatientDetail } from "@/domain/entity/patient/patient-info-entity";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPatientUsecase {
  constructor(private readonly patientRepo: PatientRepository) {}

  async execute(patientUuid: string): Promise<SATResult<PatientDetail, SATError>> {
    return this.patientRepo.fetchPatient(patientUuid);
  }
}
